import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { H4, H5, NewButton, Icon, Tooltip } from '../../../../../components';
import { SuggestedRewordingItem } from '../../atoms';
import { ReactComponent as LogoMobile } from '../../../../../assets/images/logo-mobile.svg';

const AssetCannedAnswerContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 24px;
  height: 100%;
  gap: 20px;
  width: 100%;
`;

const SuggestedContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 24px;
  height: 100%;
  gap: 20px;
  width: 100%;
  max-width: 600px;
  margin: 0 auto;
`;

const SuggestedRewordingList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const SuggestedRewordingLabel = styled(H5)`
  padding-left: 4px;
  display: flex;
  align-items: center;
  gap: 4px;
`;

const ActionsContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const SuggestedRewordingItemContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 4px;
  width: 100%;
`;

const AnswerBody = styled(H4)`
  text-align: center;
  max-width: 450px;
`;

const StyledMobileLogo = styled(LogoMobile)`
  flex-shrink: 0;
`;

const AssetCannedAnswer = ({
  answerBody,
  onCreateQuestion,
  questionId,
  isLastQuestion,
  isCategoryError,
  onRetryQuestion = null,
  onDeleteQuestion = null,
  rephrasedQuestions = []
}) => (
  <AssetCannedAnswerContainer>
    <StyledMobileLogo />
    <AnswerBody>{answerBody}</AnswerBody>
    {isLastQuestion && onDeleteQuestion && onRetryQuestion && (
      <ActionsContainer>
        <NewButton onClick={onRetryQuestion}>
          <Icon name='sync' displaySize={20} />
          {isCategoryError ? 'Try anyway' : 'Retry'}
        </NewButton>
        <NewButton onClick={onDeleteQuestion}>
          <Icon name='trash' displaySize={20} />
          Remove question
        </NewButton>
      </ActionsContainer>
    )}

    <SuggestedContainer>
      {rephrasedQuestions?.length > 0 && (
        <SuggestedRewordingItemContainer>
          <SuggestedRewordingLabel>
            Suggested rewording
            <Tooltip content='Sometimes a small change in wording can make all the difference. Here are some rephrased versions that might work better.'>
              <Icon name='information' displaySize={16} color='var(--content-subtitle)' />
            </Tooltip>
          </SuggestedRewordingLabel>
          <SuggestedRewordingList>
            {rephrasedQuestions?.map((rewording) => (
              <SuggestedRewordingItem
                key={rewording}
                question={rewording}
                onClick={() => onCreateQuestion(rewording, questionId)}
              />
            ))}
          </SuggestedRewordingList>
        </SuggestedRewordingItemContainer>
      )}
    </SuggestedContainer>
  </AssetCannedAnswerContainer>
);

AssetCannedAnswer.propTypes = {
  answerBody: PropTypes.string.isRequired,
  rephrasedQuestions: PropTypes.arrayOf(PropTypes.string),
  onCreateQuestion: PropTypes.func.isRequired,
  questionId: PropTypes.string.isRequired,
  onRetryQuestion: PropTypes.func,
  onDeleteQuestion: PropTypes.func,
  isLastQuestion: PropTypes.bool.isRequired,
  isCategoryError: PropTypes.bool.isRequired
};

export { AssetCannedAnswer };
